<template>
  <div class="home">
    <!-- 返回首页 -->
    <div class="backhome" @click="backHome">
      <i class="el-icon-s-home"></i>
    </div>

    <!-- 全屏 / 退出全屏：整个驾驶舱铺满屏幕（在返回首页按钮左边） -->
    <div
      class="fs-btn"
      :title="fs ? '退出全屏（Esc）' : '全屏显示'"
      :aria-label="fs ? '退出全屏' : '全屏显示'"
      @click="toggleFs"
    >
      <svg v-if="!fs" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- ========== 全局内容层 ========== -->
    <div class="content-layer">
      <!-- 顶部标题 -->
      <div class="page-header">
        <h1>水质分析仪器 · 智能装配产线监控中心</h1>
        <p class="page-desc">
          40工位实时监控 &nbsp;|&nbsp; 生产进度 · 设备状态 · 多维异常分析
        </p>
      </div>

      <!-- 左右分栏主容器 -->
      <div class="main-container">
        <!-- ====== 左侧面板 ====== -->
        <div class="left-panel">
          <div class="left-title">📊 统计数据</div>

          <!-- 综合核心指标 -->
          <div class="total-stat">
            <div class="stat-item">
              <div class="stat-label">总工位数</div>
              <div class="stat-value">{{ totalStation }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">综合生产进度</div>
              <div class="stat-value">{{ totalProgress }}%</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">正常运行工位</div>
              <div class="stat-value success">{{ normalCount }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">异常工位总数</div>
              <div class="stat-value warn">{{ errorCount }}</div>
            </div>
            <div
              class="stat-item"
              v-for="(err, index) in errorList"
              :key="index"
            >
              <div class="stat-label">⚑ {{ err.name }}</div>
              <div class="stat-value" :class="'err' + (index + 1)">
                {{ err.count }}
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-label">高进度工位(≥70%)</div>
              <div class="stat-value success">{{ highPro }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">低进度工位(&lt;30%)</div>
              <div class="stat-value warn">{{ lowPro }}</div>
            </div>
          </div>

          <!-- 图表切换 -->
          <div class="chart-btn-group">
            <button
              class="chart-btn"
              :class="{ active: activeChart === 'progress' }"
              @click="activeChart = 'progress'"
            >
              进度分布
            </button>
            <button
              class="chart-btn"
              :class="{ active: activeChart === 'error' }"
              @click="activeChart = 'error'"
            >
              异常占比
            </button>
            <button
              class="chart-btn"
              :class="{ active: activeChart === 'trend' }"
              @click="activeChart = 'trend'"
            >
              产能趋势
            </button>
          </div>

          <!-- 图表 -->
          <div class="chart-box" :class="{ show: activeChart === 'progress' }">
            <div ref="chartProgress" class="chart"></div>
          </div>
          <div class="chart-box" :class="{ show: activeChart === 'error' }">
            <div ref="chartError" class="chart"></div>
          </div>
          <div class="chart-box" :class="{ show: activeChart === 'trend' }">
            <div ref="chartTrend" class="chart"></div>
          </div>

          <!-- 异常明细 -->
          <div class="error-list-panel">
            <div class="panel-title">实时异常工位明细</div>
            <div
              v-if="errorStationList.length === 0"
              class="error-item"
              style="color: #8eb5c9"
            >
              暂无异常工位
            </div>
            <div
              v-for="item in errorStationList"
              :key="item.id"
              class="error-item"
              :class="item.error.cls"
            >
              ▸ 工位{{ item.id }}：{{ item.error.name }}
            </div>
          </div>
        </div>

        <!-- ====== 右侧面板 ====== -->
        <div class="right-panel">
          <div class="legend-box">
            <div class="legend-item">
              <span class="legend-dot dot-normal"></span>
              <span>运行正常</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot dot-error"></span>
              <span>工位异常</span>
            </div>
          </div>

          <div class="work-card-wrap">
            <div
              v-for="(item, idx) in stationData"
              :key="item.id"
              class="work-card"
              :class="item.normal ? 'normal' : 'abnormal'"
              :style="{ animationDelay: idx * 0.015 + 's' }"
            >
              <div class="card-title">工位 {{ item.id }}</div>
              <div
                class="card-status"
                :class="item.normal ? 'status-normal' : 'status-abnormal'"
              >
                {{ item.normal ? '运行正常' : '设备异常' }}
              </div>
              <div class="progress-bar">
                <div
                  class="progress-inner"
                  :class="item.normal ? 'prog-normal' : 'prog-abnormal'"
                  :style="{ width: item.progress + '%' }"
                ></div>
              </div>
              <div class="prog-text">{{ item.progress }}%</div>
              <div v-if="!item.normal" class="error-text" :class="item.error.cls">
                {{ item.error.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import UserInfoUtils from '@/utils/userInfoUtils.js';
/* 全屏开关：优先原生 Fullscreen API，不支持时自动退回铺满视口（与工位看板共用同一份实现） */
import { toggleFullscreen, onFullscreenChange } from '../js/fullscreen.js';

const ERROR_TYPES = [
  { name: '任务下达齐套率异常', cls: 'e1' },
  { name: '生产超期', cls: 'e2' },
  { name: '入库超期', cls: 'e3' },
  { name: '结案超期', cls: 'e4' },
  { name: '采购订单超期', cls: 'e5' },
  { name: '设计变更', cls: 'e6' }
];

export default {
  name: 'WaterQualityDashboard',
  data() {
    return {
      totalStation: 40,
      stationData: [],
      errorList: ERROR_TYPES.map(e => ({ ...e, count: 0 })),
      totalProgress: '0',
      normalCount: 0,
      errorCount: 0,
      highPro: 0,
      lowPro: 0,
      activeChart: 'progress',
      chartProgress: null,
      chartError: null,
      chartTrend: null,
      timer: null,
      fs: false, // 是否处于全屏（按钮图标 / 提示跟着切）
    };
  },
  computed: {
    errorStationList() {
      return this.stationData.filter(item => !item.normal);
    }
  },
  mounted() {
    this.initData();
    this.$nextTick(() => {
      this.initCharts();
      this.startAutoRefresh();
    });
    // 原生全屏按 ESC / F11 退出时不经过按钮，靠这个把按钮图标同步回来
    this.offFsChange = onFullscreenChange((on) => { this.fs = on; });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (this.offFsChange) this.offFsChange(); // 摘掉全屏状态监听

    if (this.chartProgress && this.chartProgress.dispose) {
      this.chartProgress.dispose();
    }
    if (this.chartError && this.chartError.dispose) {
      this.chartError.dispose();
    }
    if (this.chartTrend && this.chartTrend.dispose) {
      this.chartTrend.dispose();
    }
  },
  methods: {
    backHome() {
      // 返回主页：按权限决定（有项目管理权限→项目主页，否则→合同主页），避免跳转到无权限的项目页
      this.$router.push(UserInfoUtils.getDefaultHomeRoute());
    },
    /* ---------- 全屏 ---------- */
    // 整个驾驶舱铺满屏幕：优先原生全屏，不支持时自动退回「铺满视口」
    // （切换后工具里会补发一次 resize，echarts 会按新尺寸重排）
    toggleFs() {
      toggleFullscreen(this.$el, (on) => { this.fs = on; });
    },

    initData() {
      const list = [];
      for (let i = 1; i <= this.totalStation; i++) {
        const r = Math.random();
        const normal = r < 0.7;
        list.push({
          id: i,
          normal,
          progress: normal
            ? Math.floor(Math.random() * 70) + 30
            : Math.floor(Math.random() * 40),
          error: normal
            ? null
            : ERROR_TYPES[Math.floor(Math.random() * ERROR_TYPES.length)]
        });
      }
      this.stationData = list;
      this.calcStat();
    },

    calcStat() {
      const normal = this.stationData.filter(i => i.normal);
      const error = this.stationData.filter(i => !i.normal);

      this.totalProgress = (
        this.stationData.reduce((s, i) => s + i.progress, 0) / this.totalStation
      ).toFixed(1);

      this.normalCount = normal.length;
      this.errorCount = error.length;

      const counts = Array(ERROR_TYPES.length).fill(0);
      error.forEach(e => {
        const idx = ERROR_TYPES.findIndex(t => t.name === e.error.name);
        if (idx >= 0) counts[idx]++;
      });

      this.errorList = ERROR_TYPES.map((e, i) => ({
        ...e,
        count: counts[i]
      }));

      this.highPro = this.stationData.filter(i => i.progress >= 70).length;
      this.lowPro = this.stationData.filter(i => i.progress < 30).length;
    },

    initCharts() {
      this.chartProgress = echarts.init(this.$refs.chartProgress);
      this.chartError = echarts.init(this.$refs.chartError);
      this.chartTrend = echarts.init(this.$refs.chartTrend);
      this.refreshCharts();
    },

    refreshCharts() {
      this.chartProgress.setOption(this.getProgressOption());
      this.chartError.setOption(this.getErrorOption());
      this.chartTrend.setOption(this.getTrendOption());
    },

    getProgressOption() {
      const low = this.stationData.filter(i => i.progress < 30).length;
      const mid = this.stationData.filter(
        i => i.progress >= 30 && i.progress < 70
      ).length;
      const high = this.stationData.filter(i => i.progress >= 70).length;

      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 20, right: 20, top: 20, bottom: 20 },
        xAxis: {
          type: 'category',
          data: ['0-30%', '30-70%', '70-100%'],
          axisLine: { lineStyle: { color: '#8eb5c9' } }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#8eb5c9' } }
        },
        series: [
          {
            type: 'bar',
            barWidth: '55%',
            data: [
              { value: low, itemStyle: { color: '#ff8c42' } },
              { value: mid, itemStyle: { color: '#00aeff' } },
              { value: high, itemStyle: { color: '#00d4aa' } }
            ]
          }
        ]
      };
    },

    getErrorOption() {
      return {
        tooltip: { trigger: 'item' },
        legend: {
          bottom: 0,
          textStyle: { color: '#8eb5c9', fontSize: 10 }
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            label: { show: false },
            data: this.errorList.map((e, i) => ({
              name: e.name,
              value: this.stationData.filter(
                s => !s.normal && s.error.name === e.name
              ).length,
              itemStyle: {
                color: [
                  '#ff4d6a',
                  '#ff6b9d',
                  '#c084fc',
                  '#60a5fa',
                  '#22d3ee',
                  '#34d399'
                ][i]
              }
            }))
          }
        ]
      };
    },

    getTrendOption() {
      const hours = ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00'];
      const values = hours.map(() => Math.floor(Math.random() * 25) + 60);

      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 20, right: 20, top: 20, bottom: 20 },
        xAxis: {
          type: 'category',
          data: hours,
          axisLine: { lineStyle: { color: '#8eb5c9' } }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#8eb5c9' } }
        },
        series: [
          {
            type: 'line',
            smooth: true,
            data: values,
            lineStyle: { color: '#00aeff', width: 2 },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(0,174,255,0.3)' },
                  { offset: 1, color: 'rgba(0,174,255,0.05)' }
                ]
              }
            }
          }
        ]
      };
    },

    startAutoRefresh() {
      this.timer = setInterval(() => {
        this.initData();
        this.refreshCharts();
      }, 5000);
    }
  }
};
</script>


<style scoped>
/* ================= 布局 ================= */
.home {
  width: 100%;
  height: 100vh;
  background: #0a1a2a;
  overflow: hidden;
  position: relative;
}

.backhome {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  color: #0595eb;
  cursor: pointer;
  z-index: 10;
}

/* 全屏按钮：右上角，返回首页按钮左边 */
.fs-btn {
  position: absolute;
  top: 10px;
  right: 62px;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  border: 1px solid rgba(5, 149, 235, 0.3);
  color: #0595eb;
  background: rgba(10, 26, 42, .55);
  cursor: pointer;
  z-index: 10;
  transition: color .15s, background .15s;
}
.fs-btn svg { width: 18px; height: 18px; }
.fs-btn:hover { color: #fff; background: rgba(5, 149, 235, 0.3); }
/* 原生全屏 / 兜底伪全屏时都要铺满整个屏幕 */
.home:fullscreen { width: 100vw; height: 100vh; background: #0a1a2a; }
.home.is-fs {
  position: fixed !important; inset: 0; z-index: 1200;
  width: 100vw; height: 100vh; background: #0a1a2a;
}

.content-layer {
  width: 100%;
  height: 100vh;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
}

.page-header {
  text-align: center;
  flex-shrink: 0;
}

.page-header h1 {
  font-size: 26px;
  font-weight: 700;
  background: linear-gradient(90deg, #00aeff, #00d4ff, #00aeff);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: shine 3s infinite;
}

@keyframes shine {
  0%,
  100% {
    background-position: 0% center;
  }
  50% {
    background-position: 200% center;
  }
}

.page-desc {
  font-size: 12px;
  color: rgba(142, 181, 201, 0.8);
  margin-top: 2px;
}

.main-container {
  display: flex;
  gap: 14px;
  flex: 1;
  min-height: 0;
}

/* ================= 左侧 ================= */
.left-panel {
  width: 22%;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.left-title {
  font-size: 15px;
  color: #00aeff;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid rgba(0, 174, 255, 0.2);
}

.total-stat {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(10, 30, 55, 0.75);
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 10px;
  color: #8eb5c9;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #00aeff;
}

.stat-value.warn {
  color: #ff8c42;
}

.stat-value.success {
  color: #00d4aa;
}

.chart-btn-group {
  display: flex;
  gap: 6px;
}

.chart-btn {
  flex: 1;
  padding: 7px 0;
  font-size: 11px;
  border-radius: 8px;
  border: 1px solid rgba(0, 174, 255, 0.2);
  background: rgba(10, 30, 55, 0.7);
  color: #8eb5c9;
  cursor: pointer;
}

.chart-btn.active {
  background: linear-gradient(
    135deg,
    rgba(0, 100, 180, 0.6),
    rgba(0, 174, 255, 0.35)
  );
  color: #fff;
}

.chart-box {
  flex: 1;
  display: none;
  border-radius: 12px;
  background: rgba(10, 30, 55, 0.75);
}

.chart-box.show {
  display: block;
}

.chart {
  width: 100%;
  height: 100%;
}

/* ================= 异常列表 ================= */
.error-list-panel {
  height: 160px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(10, 30, 55, 0.75);
  overflow: hidden;
}

.panel-title {
  font-size: 12px;
  color: #8eb5c9;
  margin-bottom: 6px;
}

.error-item {
  font-size: 10px;
  line-height: 1.8;
}

.e1 {
  color: #ff4d6a;
}
.e2 {
  color: #ff6b9d;
}
.e3 {
  color: #c084fc;
}
.e4 {
  color: #60a5fa;
}
.e5 {
  color: #22d3ee;
}
.e6 {
  color: #34d399;
}

/* ================= 右侧 ================= */
.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-box {
  display: flex;
  justify-content: center;
  gap: 28px;
  padding: 8px;
  border-radius: 10px;
  background: rgba(10, 30, 55, 0.7);
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.dot-normal {
  background: #00d4aa;
}
.dot-error {
  background: #ff4d6a;
}

.work-card-wrap {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 10px;
}

.work-card {
  background: rgba(15, 35, 60, 0.85);
  border-radius: 12px;
  padding: 8px;
  border-left: 3px solid;
  display: flex;
  flex-direction: column;
}

.work-card.normal {
  border-left-color: #00d4aa;
}

.work-card.abnormal {
  border-left-color: #ff4d6a;
}

.card-title {
  font-size: 12px;
  color: #e0e8f0;
}

.card-status {
  font-size: 9px;
  margin: 4px 0;
  padding: 1px 6px;
  border-radius: 8px;
  width: fit-content;
}

.status-normal {
  background: rgba(0, 212, 170, 0.12);
  color: #00d4aa;
}

.status-abnormal {
  background: rgba(255, 77, 106, 0.12);
  color: #ff4d6a;
}

.progress-bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
}

.progress-inner {
  height: 100%;
}

.prog-normal {
  background: linear-gradient(90deg, #00a87c, #00d4aa);
}

.prog-abnormal {
  background: linear-gradient(90deg, #cc2244, #ff4d6a);
}

.prog-text {
  font-size: 9px;
  color: #8eb5c9;
  margin-top: 2px;
}

.error-text {
  font-size: 9px;
}
</style>